import { BUTTON_SELECTED, LINK_SELECTED, CLOSE_BUTTON_SELECTED } from 'config/constants/gaCommonActions';
import { createEventCreator as event } from './ga';

export type EditDetailsPopUpActionType =
  | 'Link Selected'
  | 'Email Address Updated'
  | 'Phone Number Updated'
  | 'QFF Updated'
  | 'ABN Updated'
  | 'Save Changes Button Selected';

export type AddToCalendarLinkSelectedActionType =
  | 'Link Expanded'
  | 'Outlook Selected'
  | 'Google Selected'
  | 'Apple Selected'
  | 'Yahoo Selected';

export const EDIT_DETAILS_POP_UP_ACTION: Record<string, Partial<EditDetailsPopUpActionType>> = {
  EMAIL_ADDRESS_UPDATED: 'Email Address Updated',
  PHONE_NUMBER_UPDATED: 'Phone Number Updated',
  QFF_UPDATED: 'QFF Updated',
  ABN_UPDATED: 'ABN Updated',
  SAVE_CHANGES_BUTTON_SELECTED: 'Save Changes Button Selected',
};
export const ADD_TO_CALENDAR_LINK_SELECTED_ACTION: Record<string, Partial<AddToCalendarLinkSelectedActionType>> = {
  LINK_EXPANDED: 'Link Expanded',
  OUTLOOK: 'Outlook Selected',
  GOOGLE: 'Google Selected',
  APPLE: 'Apple Selected',
  YAHOO: 'Yahoo Selected',
};

export const cancellationOptionButton = event((location: 'Top' | 'Bottom' | 'Policy') => ({
  category: 'Cancellation Options Button',
  action: `${location} ${BUTTON_SELECTED}`,
}));

export const changeDatesLinkSelected = event(() => ({
  category: 'Change Dates Link',
  action: LINK_SELECTED,
}));

export const showHotelPopUpLinkSelected = event(() => ({
  category: 'Show Hotel Pop Up',
  action: LINK_SELECTED,
}));

export const showHotelPopUpCloseButtonSelected = event(() => ({
  category: 'Show Hotel Pop Up',
  action: CLOSE_BUTTON_SELECTED,
}));

export const yourHotelsReturnLinkSelected = event(() => ({
  category: 'Your Hotels Return Link',
  action: LINK_SELECTED,
}));

export const getDirectionsLinkSelected = event(() => ({
  category: 'Get Directions Link',
  action: LINK_SELECTED,
}));

export const checkInInstructionsDropdown = event((isOpen: boolean) => ({
  category: 'Check-in Instructions Dropdown',
  action: isOpen ? 'View More Selected' : 'View Less Selected',
}));

export const roomInformationPopUpLinkSelected = event(() => ({
  category: 'Room Information Pop Up',
  action: LINK_SELECTED,
}));

export const roomInformationPopUpCloseButtonSelected = event(() => ({
  category: 'Room Information Pop Up',
  action: CLOSE_BUTTON_SELECTED,
}));

export const addToCalendarLinkSelected = event((action: AddToCalendarLinkSelectedActionType) => ({
  category: 'Add To Calendar Link',
  action: action,
}));

export const editDetailsPopUp = event((action: EditDetailsPopUpActionType) => ({
  category: 'Edit Details Pop Up',
  action: action,
}));

export const updateGuestDetailsLinkSelected = event(() => ({
  category: 'Update Guest Details',
  action: LINK_SELECTED,
}));

export const updateCreditCardDetailsLinkSelected = event(() => ({
  category: 'Update Credit Card Details',
  action: LINK_SELECTED,
}));

export const changeYourBookingLinkSelected = event(() => ({
  category: 'Change Your Booking',
  action: LINK_SELECTED,
}));

export const cancelYourBookingLinkSelected = event(() => ({
  category: 'Cancel Your Booking',
  action: LINK_SELECTED,
}));

export const contactUsLinkSelected = event(() => ({
  category: 'Contact Us',
  action: LINK_SELECTED,
}));

export const downloadInvoiceLinkSelected = event((location: 'Manage your booking' | 'Charges') => ({
  category: 'Download Invoice',
  action: `${location} ${LINK_SELECTED}`,
}));

export const downloadAppleWalletPassLinkSelected = event((location: 'Manage your booking' | 'Booking details') => ({
  category: 'Download Apple Wallet Pass',
  action: `${location} ${LINK_SELECTED}`,
}));

export const paymentBreakdownSelected = event((isOpen: boolean) => ({
  category: 'Payment Dropdown',
  action: isOpen ? 'Link Expanded' : 'Link Collapsed',
}));

export const hotelFeesBreakdownSelected = event((isOpen: boolean) => ({
  category: 'Hotel Fees Dropdown',
  action: isOpen ? 'Link Expanded' : 'Link Collapsed',
}));

export const scheduledPaymentCreditCardExpiredUpdateCreditCard = event(() => ({
  category: 'Scheduled Payment Alert - Credit Card Expired',
  action: `Update Credit Card ${LINK_SELECTED}`,
}));

export const scheduledPaymentFailedUpdateCreditCard = event(() => ({
  category: 'Scheduled Payment Alert - Failed Payment',
  action: `Update Credit Card ${LINK_SELECTED}`,
}));

export const viewTravelRequirementsLinkSelected = event(() => ({
  category: 'Travel Requirements',
  action: `View Travel Requirements ${LINK_SELECTED}`,
}));

export const updatePaymentDetailsModalLinkSelected = event((type: 'call customer support' | 'call international customer support') => ({
  category: 'Update Payment Details Modal',
  action: `${LINK_SELECTED} - ${type}`,
}));

export const updatePaymentDetailsModalUpdateSelected = event(() => ({
  category: 'Update Payment Details Modal',
  action: `${LINK_SELECTED} - update payment details`,
}));

export const updatePaymentDetailsModalDismissSelected = event(() => ({
  category: 'Update Payment Details Modal',
  action: `${LINK_SELECTED} - dismiss payment details prompt`,
}));
export const updatePaymentDetailsAlertSelected = event(() => ({
  category: 'Update Payment Details Alert',
  action: `${LINK_SELECTED} - update payment details`,
}));
